<template>
    <b-container fluid>
        <hr/>
        <h3>Logs</h3>
        <hr/>
        <div class="row w-50 mx-auto">
            <div class="col-4">
                <h6>Log Category</h6>
                <v-skeleton-loader
                        :loading="this.loadingIndex"
                        transition='fade-transition'
                        ref="skeleton"
                        type="list-item">
                    <b-form-select v-model="selectedCategory" :options="categories"
                                   @change="getAllFilesForCategory()" autofocus></b-form-select>

                </v-skeleton-loader>
            </div>

            <div class="col-4">
                <h6>File name</h6>
                <v-skeleton-loader
                        :loading="this.loadingFiles"
                        transition='fade-transition'
                        ref="skeleton"
                        type="list-item">
                    <b-form-select v-model="selectedFile" :options="files" @change="setDownloadUrl()"
                                   :disabled="!selectedCategory"></b-form-select>
                </v-skeleton-loader>
            </div>

            <div class="col-4">
                <h6>Action</h6>
                <v-btn :style="primaryStyle" :href="url" target="_blank" :disabled="!selectedFile">Download log
                </v-btn>
            </div>
        </div>
        <hr/>

    </b-container>
</template>

<script>
    import LogRepository from '../../repositories/log.repository';

    export default {
        data() {
            return {
                url: '',
                selectedCategory: '',
                selectedFile: '',
                categories: [],
                files: [],
                loadingIndex: false,
                loadingFiles: false,
            }
        },
        created() {
            this.getAllLogCategories();
        },
        methods: {
            getAllLogCategories() {
                this.loadingIndex = true;
                this.loadingFiles = true;
                LogRepository.getAllLogCategories().then(res => {
                    if (res.data.success) {
                        this.categories = res.data.categories;
                    }
                    this.loadingIndex = false;
                    this.loadingFiles = false;
                });
            },

            getAllFilesForCategory() {
                this.loadingFiles = true;
                LogRepository.getAllFilesForCategory(this.selectedCategory).then(res => {
                    if (res.data.success) {
                        this.files = res.data.files;
                    } else {
                        this.files = [];
                    }

                    this.selectedFile = null;
                    this.loadingFiles = false;
                }).catch(error => {
                    this.loadingFiles = false;
                    this.$bvToast.toast('Looks like something went wrong whilst getting the logs.', {
                        title: `Log error`,
                        variant: 'danger',
                        solid: true
                    });
                });
            },

            setDownloadUrl() {
                this.url = `${process.env.VUE_APP_API_URL}/log/file/${this.selectedCategory}?file=${this.selectedFile}`;
            }
        }
    }
</script>
